<template>
<div class="chapter">
<div class="inner_page">
<div class="sgc-1" id="untitled-1"></div>
<div class="calibre1" id="untitled-11">
<div class="calibre1">
<p class="normal"><br class="calibre1"/></p>
</div>
<div class="calibre1">
<p class="songlyrics-centered"><br class="calibre1"/></p>
<p class="songlyrics-centered"><br class="calibre1"/></p>
<p class="songlyrics-centered"><br class="calibre1"/></p>
<p class="songlyrics-centered"><br class="calibre1"/></p>
<p class="songlyrics-centered"><br class="calibre1"/></p>
<p class="songlyrics-centered"><br class="calibre1"/></p>
<p class="songlyrics-centered"><br class="calibre1"/></p>
<p class="songlyrics-centered"><br class="calibre1"/></p>
<p class="songlyrics-centered">The harvester is near.</p>
<p class="songlyrics-centered">His blade is on your skin.</p>
<p class="songlyrics-centered"><br class="calibre1"/></p>
<p class="songlyrics-centered"><span class="no-style-override4">Sixpence None the Richer</span><span class="no-style-override5"><br class="calibre1"/></span></p>
<p class="songlyrics-centered">Love</p>
<p class="calibre2" id="calibre_pb_12"></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0000_split_005.vue?2b55cd07